import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Input, message } from "antd";
import { uploadImage } from "../../api/service";

const ImageUpload = ({ onUploadSuccess, id }) => {
  const formData = new FormData();

  const handleChangeAndUploadImage = async (event) => {
    try {
      if (event.target.files[0]) {
        const formData = new FormData();
        formData.append('image', event.target.files[0]);
        const response = await uploadImage(formData);
        if (response) {
          onUploadSuccess(response.url);
          message.success("Image upload successful");
        }
      }
    } catch (error) {
      message.error("Error while uploading image");
    }
  };

  return (
    <div className="w-full">
      <label htmlFor={id} className=" text-black">
        <div className="flex justify-center items-center py-1.5 border border-solid border-boxGrey rounded cursor-pointer">
          <UploadOutlined /> &nbsp; Upload Image
          <Input
            type="file"
            data-testid={id}
            id={id}
            accept="image/*"
            className="!w-full"
            style={{ display: "none" }}
            onChange={handleChangeAndUploadImage}
          />
        </div>
      </label>
    </div>
  );
};

export default ImageUpload;
